module.exports = __webpack_public_path__ + "img/trunk_7x2.a8f24f16.svg";